<template>
  <b-container fluid style="max-width:1200px;">
    <template v-if="!restrictedBrand">
      <b-row style="margin-top: 4em">
        <b-col>
          <h2 class="text-secondary">
            <i>{{ $t("globals.item") + " " + $route.params.id }}</i>
          </h2>
        </b-col>
        <b-col>
          <!-- Disabled
          <b-btn
            v-if="!edit"
            variant="danger"
            style="float: right; margin-left: 0.3em;"
            @click="showDeleteAlertModal = true"
          >
            {{ $t("globals.delete") }}
          </b-btn>
          -->
          <b-btn
            v-if="!edit"
            variant="info"
            style="float: right;"
            @click="edit = true"
          >
            {{ $t("globals.edit") }}
          </b-btn>
          <b-btn
            variant="success"
            style="float: right; margin-left: 0.3em"
            v-if="edit"
            @click="saveItem"
            :disabled="!requiredData"
          >
            {{ $t("globals.save") }}
          </b-btn>
          <b-btn
            variant="warning"
            style="float: right;"
            v-if="edit"
            @click="cancelEdit"
          >
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <b-card bg-variant="light">
            <b-row>
              <b-col>
                <span>{{ $t("globals.brand") }}:</span>
                <b-form-select
                  v-model="item.brand"
                  :options="getBrandOptions"
                  :disabled="!edit"
                />
                <span>{{ $t("globals.type") }}:</span>
                <b-form-input
                  v-model="item.item_type"
                  :disabled="!edit"
                ></b-form-input>
                <span>{{ $t("globals.name") }}:</span>
                <b-form-input
                  v-model="item.item_name"
                  :disabled="!edit"
                ></b-form-input>
                <span>{{ $t("globals.fleet_size") }}:</span>
                <b-form-input
                  v-model.number="item.fleet_size"
                  :disabled="!edit"
                ></b-form-input>
                <span>{{ $t("globals.contract_duration") }}:</span>
                <b-form-input
                  v-model.number="item.contract_duration"
                  :disabled="!edit"
                ></b-form-input>
                <span>{{ $t("globals.exact_code") }}:</span>
                <b-form-select
                  v-model="item.exact_code_id"
                  :options="exactCodeOptions"
                  :disabled="!edit"
                />
                <div class="row">
                  <div class="col">
                    <span>{{ $t("globals.is_device") }}:</span>
                    <b-form-radio-group
                      v-model="item.is_device"
                      :options="isDeviceOptions"
                      :disabled="!edit"
                    />
                  </div>
                  <div class="col">
                    <span>{{ $t("globals.is_lease") }}:</span>
                    <b-form-radio-group
                      v-model="item.is_lease"
                      :options="isDeviceOptions"
                      :disabled="!edit"
                    />
                  </div>
                  <div class="col " v-if="getUserBrandPermissions.super_admin">
                    <span>{{ $t("globals.displayed") }}:</span>
                    <b-form-radio-group
                      v-model="item.displayed"
                      :options="displayedOptions"
                      :disabled="!edit"
                    />
                  </div>
                </div>
              </b-col>
              <b-col>
                <span>{{ $t("globals.price_once") }}:</span>
                <b-input-group>
                  <b-form-input
                    v-model.number="item.price_one_time"
                    :disabled="!edit"
                  ></b-form-input>
                  <b-form-input
                    :placeholder="
                      currencyFormat(
                        item.price_one_time,
                        item.currency
                      ).toString()
                    "
                    disabled
                  >
                  </b-form-input>
                </b-input-group>
                <span>{{ $t("globals.price_monthly") }}:</span>
                <b-input-group>
                  <b-form-input
                    v-model.number="item.price_per_month"
                    :disabled="!edit"
                  ></b-form-input>
                  <b-form-input
                    :placeholder="
                      currencyFormat(
                        item.price_per_month,
                        item.currency
                      ).toString()
                    "
                    disabled
                  >
                  </b-form-input>
                </b-input-group>
                <span>{{ $t("globals.costs") }}:</span>
                <b-input-group>
                  <b-form-input
                    v-model.number="item.costs"
                    :disabled="!edit"
                  ></b-form-input>
                  <b-form-input
                    :placeholder="
                      currencyFormat(item.costs, item.currency).toString()
                    "
                    disabled
                  >
                  </b-form-input>
                </b-input-group>
                <span>{{ $t("globals.vat") }}:</span>
                <b-form-input
                  v-model.number="item.vat"
                  :disabled="!edit"
                ></b-form-input>
                <span>{{ $t("globals.currency") }}:</span>
                <b-form-select
                  v-model="item.currency"
                  :options="getCurrencyOptions"
                  :disabled="!edit"
                />
                <span>{{ $t("globals.description") }}:</span>
                <b-form-input
                  v-model="item.description"
                  :disabled="!edit"
                ></b-form-input>
                <span>{{ $t("globals.kpi_type") }}:</span>
                <b-form-select
                  v-model="item.kpi_type"
                  :options="kpiTypeOptions"
                  :disabled="!edit"
                />
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <!-- Synatec products -->
      <b-row class="my-3">
        <b-col>
          <b-card bg-variant="light">
            <b-row>
              <b-col>
                <h4 class="text-secondary">
                  {{ $t("globals.synatec_products") }}
                </h4>
              </b-col>
              <b-col>
                <b-btn
                  v-if="getUserBrandPermissions.manage_synatec_products"
                  class="m-1 float-right"
                  size="sm"
                  v-b-modal.new-synatec-product-modal
                >
                  {{ $t("globals.add_synatec_product") }}
                </b-btn>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-table
                  bordered
                  striped
                  small
                  primary-key="id"
                  :fields="fields"
                  :items="item.synatec_products"
                >
                  <template v-slot:cell(action)="row">
                    <b-btn
                      v-if="getUserBrandPermissions.manage_synatec_products"
                      class="m-1 float-right"
                      size="sm" variant="danger" pill
                      @click="removeSynatecProduct(row.item.id)"
                    >
                      <v-icon name="trash"></v-icon>
                    </b-btn>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <!-- webshop -->
      <b-row class="my-3">
        <b-col>
          
          <webshop :item_id="parseInt($route.params.id)" :webshop_item="item.webshop_item" :default_title="item.item_name" :parent_editable="edit" />
        </b-col>
      </b-row>
      <!-- Item delete modal -->
      <b-modal
        :visible="showDeleteAlertModal"
        size="sm"
        centered
        hide-footer
        hide-header
        no-close-on-backdrop
        no-close-on-esc
      >
        <h4>{{ $t("globals.are_you_sure_you_want_to_delete_this_item") }}?</h4>
        <hr />
        <b-btn @click="deleteItem" variant="success">
          {{ $t("globals.yes") }}
        </b-btn>
        <b-btn
          style="float: right;"
          variant="warning"
          @click="showDeleteAlertModal = false"
        >
          {{ $t("globals.no") }}
        </b-btn>
      </b-modal>
      <!-- Add synatec product modal -->
      <b-modal
        id="new-synatec-product-modal"
        size="md"
        centered
        hide-footer
      > 
        <b-row>
          <b-col>
            <h4>{{ $t("globals.add_synatec_product") }}</h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span>{{ $t("globals.name") }}:</span>
            <b-form-input v-model="newSynatecProduct.name"></b-form-input>
          </b-col>
          <b-col cols="12">
            <span>{{ $t("globals.synatec_code") }}:</span>
            <b-form-input v-model="newSynatecProduct.code"></b-form-input>
          </b-col>
        </b-row>
        <hr />
        <b-btn
          class="float-right"
          variant="success"
          @click="saveNewSynatecProduct"
        >
          {{ $t("globals.save") }}
        </b-btn>
      </b-modal>
    </template>
  </b-container>
</template>

<script>
import { currencyFormat } from "@/helpers/price";
import { mapMutations, mapGetters, mapActions } from "vuex";
import systemRestriction from "@/mixins/systemRestriction";

export default {
  mixins: [systemRestriction],
  systemRestrictionReload: "fetchItem",
  components:{
    webshop: () => import("@/components/webshop/webshop_item.vue"),
  },
  data() {
    return {
      showDeleteAlertModal: false,
      edit: false,
      newSynatecProduct: {
        name: "",
        code: "",
      },
      kpiTypeOptions: [],
      isDeviceOptions: [
        {
          text: "True",
          value: true
        },
        {
          text: "False",
          value: false
        }
      ],
      fields: [
        {
          key: "name",
          label: this.$t("globals.item_name")
        },
        {
          key: "synatec_code",
          label: this.$t("globals.synatec_code")
        },
        {
          key: "action",
          label: ""
        }
      ],
      item: {
        synatec_products: [],
      },
      exactCodeOptions: [],
      displayedOptions: [
        {
          text: this.$t("globals.yes"),
          value: true
        },
        {
          text: this.$t("globals.no"),
          value: false
        }
      ]
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation", "simpleFetch"]),
    ...mapActions("constants", ["fetchAllEnums"]),
    ...mapMutations(["setShowLoadingModal"]),
    currencyFormat,
    cancelEdit() {
      this.fetchItem();
      this.edit = false;
    },
    callFetchEnums() {
      this.fetchAllEnums({this_ref: this, enums: ["kpi_type"]})
        .then((res) => {
          if (res) {
            this.kpiTypeOptions = res.kpi_type;
          }
        })
    },
    deleteItem() {
      /*
      let data = {
        query: `
          mutation { 
            res: BillingItemDelete(id: ${parseInt(this.$route.params.id)} )
          }
        `
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.$router.push({ name: "allitems" });
      });
      */
    },
    saveNewSynatecProduct() {
      let data = {
        query: `
          mutation { 
            res: BillingItemAddSynatecProduct(
              billing_item_id: ${parseInt(this.$route.params.id)},
              synatec_product_name: "${this.newSynatecProduct.name}",
              synatec_product_code: "${this.newSynatecProduct.code}"
            )
          }
        `
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.$bvModal.hide("new-synatec-product-modal");

        this.newSynatecProduct.name = "";
        this.newSynatecProduct.code = "";

        this.fetchItem();
      });
    },
    removeSynatecProduct(id) {
      let data = {
        query: `
          mutation { 
            res: BillingItemRemoveSynatecProduct(
              synatec_product_id: ${parseInt(id)}
            )
          }
        `
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.fetchItem();
      });
    },
    fetchItem() {
      let data = {
        query: `
          query  {
            itemPrice (id: ${parseInt(this.$route.params.id)}) {
              id
              brand
              fleet_size
              contract_duration
              item_name
              item_type
              price_one_time
              price_per_month
              vat
              currency
              description
              is_device
              is_lease
              costs
              exact_code_id
              kpi_type
              synatec_products {
                id
                name
                synatec_code
              }
              webshop_item{
                id
                title
                description
                locales
                images
              }
              displayed
            }
          }
        `
      };

      this.setShowLoadingModal(true);
      this.simpleFetch({data, this_ref: this}).then((res) => {
        if (res && this.checkSystem(res.itemPrice.brand)) {
          this.item = res.itemPrice;
        }
      }).finally(()=>{
        this.setShowLoadingModal(false)
      });
    },
    fetchExactCodeOptions() {
      let data = {
        query: `
          query  {
            ExactCodes {
              value: id
              text: description
            }
          }
        `
      };

      this.setShowLoadingModal(true);
      this.simpleFetch({data, this_ref: this}).then((res) => {
        if (res) {
          this.exactCodeOptions = res.ExactCodes;
        }
      }).finally(()=>{
        this.setShowLoadingModal(false)
      });
    },
    saveItem() {
      this.edit = false;
      this.item.id = parseInt(this.item.id);

      delete this.item.synatec_products;
      delete this.item.webshop_item;

      let data = { 
        query: `
          mutation BillingItemCreateEdit($billing_item: BillingItemInput) {
            res: BillingItemCreateEdit (billing_item: $billing_item)
          }
        `,
        variables: { 
          billing_item: this.item
        }
      };

      this.simpleMutation({data, this_ref: this}).then(() => {
        this.fetchItem();
      });
    }
  },
  computed: {
    ...mapGetters(["getUserBrandPermissions"]),
    ...mapGetters("constants", [
      "getBrandOptions",
      "getCurrencyOptions",
    ]),
    requiredData() {
      return (
        this.item.item_type.length > 0 &&
        this.item.item_name.length > 0 &&
        this.item.fleet_size >= 0 &&
        this.item.contract_duration >= 0 &&
        this.item.price_one_time >= 0 &&
        this.item.price_per_month >= 0 &&
        this.item.costs >= 0 &&
        this.item.vat >= 0 &&
        this.item.exact_code_id != null
      );
    }
  },
  mounted() {
    this.fetchItem();
    this.fetchExactCodeOptions();
    this.callFetchEnums();
  }
};
</script>
